import { command, Command } from "@lookiero/messaging";

const RESET_CHECKOUT = "reset_checkout";

interface ResetCheckoutPayload {
  readonly aggregateId: string;
}

interface ResetCheckout extends Command<typeof RESET_CHECKOUT>, ResetCheckoutPayload {}

interface ResetCheckoutFunction {
  (payload: ResetCheckoutPayload): ResetCheckout;
}

const resetCheckout: ResetCheckoutFunction = ({ aggregateId }) => ({
  ...command({ aggregateId, name: RESET_CHECKOUT }),
});

export type { ResetCheckout };
export { RESET_CHECKOUT, resetCheckout };
